import { render, staticRenderFns } from "./BackupHealthAttorneys.vue?vue&type=template&id=617c511a"
import script from "./BackupHealthAttorneys.vue?vue&type=script&lang=js"
export * from "./BackupHealthAttorneys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports